import { ActivatedRouteSnapshot } from '@angular/router';

import { WindowPopupState } from '@pe/checkout/types';

export function openerGuard(state: WindowPopupState) {
  return (route: ActivatedRouteSnapshot) => {
    if (window.opener) {
      window.opener.postMessage({
        event: 'peWindowPopupClose',
        value: {
          queryParams: route.queryParams,
          state: route.queryParams.state ?? state,
        },
      }, '*');

      return false;
    }

    return true;
  };
}
